export enum GCActualCollectionEnum {
  Actual = 0,
}
